module.exports = "https://deal-img.imgix.net/consumer/modern/sa.2b6e4a83.png";